<template>
  <el-dialog
    v-dialog-drag
    title="发货登记"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <el-form
      ref="shipmentForm"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-position="left"
    >
      <el-form-item label="物流单号" prop="trackingNumber">
        <el-input
          v-model="form.trackingNumber"
          placeholder="请输入物流单号"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>
      
      <el-form-item label="物流公司" prop="logisticsCompany">
        <el-input
          v-model="form.logisticsCompany"
          placeholder="请输入物流公司名称"
          maxlength="100"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button 
        type="primary" 
        @click="handleSubmit"
        :loading="loading"
      >
        确认发货
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { create_logistics } from '@/api/modules/logistics.js'
import { update_order_status } from '@/api/modules/orders.js'

export default {
  name: 'ShipmentDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        trackingNumber: '',
        logisticsCompany: ''
      },
      rules: {
        trackingNumber: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
          { min: 1, max: 100, message: '物流单号长度在 1 到 100 个字符', trigger: 'blur' }
        ],
        logisticsCompany: [
          { required: true, message: '请输入物流公司名称', trigger: 'blur' },
          { min: 1, max: 100, message: '物流公司名称长度在 1 到 100 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal
        if (newVal) {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 重置表单
    resetForm() {
      this.form = {
        trackingNumber: '',
        logisticsCompany: ''
      }
      this.$nextTick(() => {
        if (this.$refs.shipmentForm) {
          this.$refs.shipmentForm.clearValidate()
        }
      })
    },
    
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.shipmentForm.validate((valid) => {
        if (valid) {
          this.submitShipment()
        } else {
          this.$message.error('请检查输入信息')
          return false
        }
      })
    },
    
    // 提交发货信息
    async submitShipment() {
      this.loading = true
      
      try {
        // 创建物流信息
        const logisticsData = {
          orderId: this.orderId,
          trackingNumber: this.form.trackingNumber,
          logisticsCompany: this.form.logisticsCompany,
          logisticsStatus: '1', // 已发货
          logisticsStatusDesc: '已发货'
        }
        
const logisticsResponse = await create_logistics(logisticsData)
        
        if (logisticsResponse.data && logisticsResponse.data.success) {
// 物流信息创建成功后，直接更新订单状态为已发货
          const statusResponse = await update_order_status(this.orderId, 'SENDING')
          
          if (statusResponse.data && statusResponse.data.success) {
            this.$message.success('发货登记成功')
            
            // 通知父组件发货成功
            this.$emit('shipment-success', {
              logisticsInfo: logisticsResponse.data.data,
              trackingNumber: this.form.trackingNumber,
              logisticsCompany: this.form.logisticsCompany
            })
            
            this.handleClose()
          } else {
            this.$message.error('订单状态更新失败: ' + (statusResponse.data?.message || '未知错误'))
          }
        } else {
          this.$message.error('物流信息创建失败: ' + (logisticsResponse.data?.message || '未知错误'))
        }
      } catch (error) {
        console.error('发货登记失败:', error)
        this.$message.error('发货登记失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}
</style>
